import { render, staticRenderFns } from "./tenantParameter.vue?vue&type=template&id=3366769a&scoped=true&"
import script from "./tenantParameter.vue?vue&type=script&lang=js&"
export * from "./tenantParameter.vue?vue&type=script&lang=js&"
import style0 from "./tenantParameter.vue?vue&type=style&index=0&id=3366769a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3366769a",
  null
  
)

export default component.exports